<template>
  <div class="dob-picker">
    <div class="flex justify-between mb-6">
      <button type="button" class="flex flex-none">
        <svg width="24" height="24"
          class="cursor-pointer"
          @click="goToPrevMonth">
          <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
        </svg>
      </button>

      <div class="flex-1 text-center font-medium">
        {{ displayingMonth.format('MMMM YYYY') }}
      </div>

      <button type="button" class="flex flex-none">
        <svg width="24" height="24"
          class="cursor-pointer"
          @click="goToNextMonth">
          <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
        </svg>
      </button>
    </div>

    <calendar-header :month="displayingMonth" />
    <calendar-grid
      :month="displayingMonth"
      :from="value"
      :to="null"
      :show-dates-in-the-past="true"
      @click="handleDateClicked" />
  </div>
</template>

<script>
import CalendarHeader from '../../components/core/DateRangePicker/CalendarHeader'
import CalendarGrid from '../../components/core/DateRangePicker/CalendarGrid'

export default {
  components: {
    CalendarHeader,
    CalendarGrid
  },
  props: ['value'],
  data () {
    return {
      displayingMonth: this.value ? this.value : moment()
    }
  },
  methods: {
    handleDateClicked (value) {
      this.$emit('input', value)
      this.$emit('close')
    },
    goToPrevMonth () {
      this.displayingMonth = this.displayingMonth.clone().add(-1, 'months')
    },
    goToNextMonth () {
      this.displayingMonth = this.displayingMonth.clone().add(1, 'months')
    }
  }
}
</script>

<style scoped>
.dob-picker ::v-deep .dp-month-display {
  display: none;
}
</style>
